<ta-page-container>
  <ta-page-header headerText="Your Marts"> </ta-page-header>

  <ta-page-body>
    <div class="ph--6">
      <div
        *ngFor="let item of (marts$ | async); last as last"
        [class.pb--4]="!last"
      >
        <ta-card>
          <ta-link [href]="item.href">
            <div class="heading--2 pv--2">{{ item.name }}</div>
          </ta-link>
        </ta-card>
      </div>
    </div>
  </ta-page-body>
</ta-page-container>
